import React from "react";
import * as c from "../../../../utils/constants/constants";
import * as msg from "../../../../utils/constants/messages";
import api from "../../../../utils/API/api";
import { forceLogout } from "../../../../commonFunctions/forceLogout";
import { Dialog, DialogTitle } from "@mui/material";
import { Info, ArrowLeft, ArrowRight } from "@mui/icons-material";
import { CustomTooltip } from "../../../../components/CustomTooltip/CustomTooltip";
import { ConvertLocalToUtc } from "../../../../commonFunctions/commonFunctions";

//import FilterAltTwoToneIcon from "@mui/icons-material/FilterAltTwoTone";

 /*------------------------------------
 When next or prev button is clicked, following is the order of execution.
 1. Get the new doc ID 
 2. Release old doc
 3. Load left side details by calling /getDoc with new doc ID
 4. Load doc pdf by calling /getDocImage with new doc ID
 */

class DocNavigation extends React.Component {
  state = {
    filter_query: {},
    noDoc: false,
    anchorEl: null,
  };
  componentDidMount = () => {
    var all_filters = JSON.parse(localStorage.getItem(c.FILTER));
    var categories = [];
    var locations = [];
    var status = [];
    var flags = [];
    if (
      all_filters.doc_cat &&
      all_filters.doc_cat !== "All" &&
      all_filters.doc_cat.length > 0
    ) {
      all_filters.doc_cat.map((cat, i) => {
        if (cat.isChecked === true && cat.name !== "Select All")
          categories.push(cat.name);
      });
    }
    if (
      all_filters.doc_loc &&
      all_filters.doc_loc !== "All" &&
      all_filters.doc_loc.length > 0
    ) {
      all_filters.doc_loc.map((loc, i) => {
        if (loc.isChecked === true && loc.name !== "Select All")
          locations.push(loc.name);
      });
    }
    if (all_filters.status && all_filters.status.length > 0) {
      all_filters.status.map((st, i) => {
        if (st.isChecked === true) status.push(st.name);
      });
    }
    if (
      all_filters.flag_data &&
      all_filters.flag_data !== "All" &&
      all_filters.flag_data.length > 0
    ) {
      all_filters.flag_data.map((fg, i) => {
      fg.enabled  && fg.tag_display_name !== "Not Flagged" && flags.push(fg.tag_display_name);
      });
    }
    var query = {
      selected_category:
        all_filters.doc_cat && all_filters.doc_cat === "All"
          ? "All"
          : categories,
      selected_status: status,
      selected_locations:
        all_filters.doc_loc && all_filters.doc_loc === "All"
          ? "All"
          : locations,
      selected_tags : all_filters.flag_data && all_filters.flag_data === "All" ? "All" : flags,
      include_tag_less_docs : all_filters.flag_data && all_filters.flag_data === "All" ? true : all_filters.flag_data[0].enabled,
      from_date: all_filters.fromDate
        ? ConvertLocalToUtc({date: all_filters.fromDate, format: "MM-DD-YYYY HH:mm:ss", startOf: "day"})
        : "",
      to_date: all_filters.toDate ? ConvertLocalToUtc({date: all_filters.toDate, format: "MM-DD-YYYY HH:mm:ss", endOf: "day"}) : "",
      search_string: all_filters.search,
      sorting: {
        sort_column: all_filters.sort_key,
        is_asc: all_filters.sort_order,
      },
      is_stat: all_filters.isStat,
    };
    this.setState({ filter_query: query });
  };

  getDocId = (doc_id, step) => {
    this.props.fullLoader("show");
    if (this.state.filter_query) {
      api.get_doc_id(this.state.filter_query, doc_id, step)
        .then((response) => {
          if (response.status === 200 && response.data.data.length === 0) {
            this.props.fullLoader("hide");
            this.setState({ noDoc: true });
            setTimeout(() => {
              this.setState({ noDoc: false });
            }, 2000);
          } else if (response.status === 200 && response.data.data[0].doc_id) {
            this.props.exitDoc(doc_id);
            this.props.getDocDetails(response.data.data[0].doc_id);
            this.props.getDocImage(response.data.data[0].doc_id);
          }
        })
        .catch((error) => {
          if (error.response.status === 401) {
            forceLogout();
          } else window.alert(msg.api_error);
        });
    }
  };
  closeDialog = () => {
    this.setState({ noDoc: false });
  };

  render() {
    return (
      <>
        <div className = "nav-buttons">
        {this.props.all_state.isSave || this.props.all_state.flag_save  ? (
          <CustomTooltip title={msg.stat_tooltip} placement="bottom-end">
            <div className="block-cursor">
              <div
                className="flex-space"
                style={{ width: "9em", color: "#aa1752" }}
              >
                <div
                  className="nav-icon"
                  style={{ paddingRight: "7px" }}
                  onClick={(e) => e.preventDefault()}
                >
                  <ArrowLeft />
                  <div>Prev</div>
                </div>
                <div
                  className="nav-icon"
                  style={{ paddingLeft: "7px" }}
                  onClick={(e) => e.preventDefault()}
                >
                  <div>Next</div>
                  <ArrowRight />
                </div>
              </div>
            </div>
          </CustomTooltip>
        ) : (
          
            <div
              className="flex-space"
              style={{ width: "9em", color: "#aa1752",cursor: "pointer" }}
            >
              <div
                className="nav-icon"
                style={{ paddingRight: "7px" }}
                onClick={() =>
                this.getDocId(this.props.all_state.doc_id, "prev")
                }
              >
                <ArrowLeft />
                <div>Prev</div>
              </div>
              <div
                className="nav-icon"
                style={{ paddingLeft: "7px" }}
                onClick={() =>
                 this.getDocId(this.props.all_state.doc_id, "next")
                }
              >
                <div>Next</div>
                <ArrowRight />
              </div>
            
          </div>
        )}
        </div>
        <Dialog open={this.state.noDoc} onClose={() => this.closeDialog()}>
          <DialogTitle>
            <div className="icon-text">
              <Info style={{ color: "var(--hti-magenta)" }} />
              <p style={{ marginLeft: "10px" }}>No Document Available</p>
            </div>
          </DialogTitle>
        </Dialog>
      </>
    );
  }
}

export default DocNavigation;
